export const Logo = () => (
  <div className="py-4 mt-4 flex flex-row justify-center">
    <img
      src="/images/Logo_large.svg"
      layout="fixed"
      width="70%"
      height="39px"
      alt="Payjim Icon"
    />
  </div>
);
